import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { RoleSysAlertRouting } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { CatalogProvider } from './catalog'
import { AlertRoutingPage } from './alert-routing-page'
import { RouteEditor } from './route-editor'
import { TargetDrawer } from './target-drawer'
import { RunDrawer } from './run-drawer'

export const LayoutAlertRouting = () =>
  <Route path="/admin/alert-routing">
    <RoleSysAlertRouting accessRead fallback={<NoAccess what="alert routing" />}>
      <CatalogProvider>
        <Switch>
          <Route path="/admin/alert-routing/routes/:routeID"><RouteEditor /></Route>
          <Route path="/admin/alert-routing/targets/:targetID"><AlertRoutingPage /><TargetDrawer /></Route>
          <Route path="/admin/alert-routing/runs/:alertID"><AlertRoutingPage /><RunDrawer /></Route>
          <Route path="/admin/alert-routing"><AlertRoutingPage /></Route>
        </Switch>
      </CatalogProvider>
    </RoleSysAlertRouting>
  </Route>
